import styled from 'styled-components';
import { PlusCircle } from '@styled-icons/fa-solid/PlusCircle';
import { Button } from 'antd';

export const Container = styled.section`
  width: 100%;
  margin: 0;

  & > span.subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
    margin: 1rem auto;
  }

  & > header {
    & > h1 {
      font-weight: 700;
      font-size: 1.625rem;
    }
  }
`;

export const GoBackContainer = styled.div`
  width: 97%;
  margin: 1rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto 1rem auto;
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
  }
`;

export const ContainerFacelift = styled.div<{ isEmitter: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${(props) => (props.isEmitter ? '0rem 1.5rem' : '2rem 1.5rem')};
`;

export const FabricationContainer = styled.section<{ isFacelift?: boolean }>`
  & input {
    ${({ isFacelift }) =>
      !isFacelift &&
      `
    width: 100%;
    padding: 0.25rem 0.5rem;
  `}

    &::placeholder {
      ${({ isFacelift, theme }) =>
        !isFacelift &&
        `
      font-size: 0.75rem';
      color: ${theme.colors.grayDark};
  `}
    }
  }

  & .ant-picker {
    width: 100%;
    padding: 0 0.5rem 0 0;
  }

  & .ant-radio-wrapper-checked {
    color: ${({ theme }) => theme.colors.blue};
    font-weight: 600;
  }

  & .ant-checkbox-wrapper {
    font-size: 0.675rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
      font-size: 0.875rem;
    }
  }
`;

export const FabricationErrorBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  & > span {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.red};
    margin-bottom: 0.5rem;
  }

  & > button {
    max-width: 12rem;
  }
`;

export const FabricationContentBlock = styled.div`
  display: flex;
  flex-direction: flex-start;
`;

export const AddItemButton = styled(Button)`
  display: flex;
  padding-left: 0;
  margin: 0.5rem 0 0 0;

  & > span {
    font-size: 0.75rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.blue};
    margin-left: 0.5rem;
  }
`;

export const CollapsePannelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PlusIcon = styled(PlusCircle)`
  width: 1rem;
  color: ${({ theme }) => theme.colors.blue};
`;
